import { createContext } from 'react';
import { Interpreter } from 'xstate';
import {
  WizardContext as WizardMachineContext,
  WizardEvent,
} from '../../state-machines/wizard-machine';

export interface IWizardContext {
  wizardService?: Interpreter<
    WizardMachineContext,
    any,
    WizardEvent,
    {
      value: any;
      context: WizardMachineContext;
    }
  >;
}

export const WizardContext = createContext<IWizardContext>({});
